import { useEffect, useState } from 'react'

import {
  loadForethoughtScript,
  loadSalesforceChat,
  openForethoughtWidget,
  removeForethoughtListener,
} from 'utils/forethought'

export const useSupportChat = ({ email }: { email: string }) => {
  const [isForethoughtWidgetLoaded, setIsForethoughtWidgetLoaded] =
    useState(false)
  const [isSalesforceChatLoaded, setIsSalesforceChatLoaded] = useState(false)

  const openSupportChat = () => {
    if (isForethoughtWidgetLoaded && isSalesforceChatLoaded) {
      openForethoughtWidget()
    } else {
      loadForethoughtScript(email ?? '', setIsForethoughtWidgetLoaded)
      loadSalesforceChat(setIsSalesforceChatLoaded)
    }
  }

  useEffect(() => {
    if (isForethoughtWidgetLoaded && isSalesforceChatLoaded) {
      window.addEventListener('message', (message) => {
        if (message.data.event === 'forethoughtWidgetLoaded') {
          openForethoughtWidget()
        } else if (message.data.event === 'forethoughtWidgetClosed') {
          window.Forethought('widget', 'hide')
        }
      })
    }
    return removeForethoughtListener
  }, [isForethoughtWidgetLoaded, isSalesforceChatLoaded])

  return {
    openSupportChat,
    setIsForethoughtWidgetLoaded,
    setIsSalesforceChatLoaded,
  }
}
